<template>
    <div class="main-inc">
        <div class="avatar-div">
            <div class="pulse-dot">
                <div class="avatar">
                    <!-- {{
                        contactStore.selectedContact?.name
                            ? contactStore.selectedContact.name
                                  .split(' ')
                                  .slice(0, 2)
                                  .map((word) => word.charAt(0))
                                  .join('')
                                  .toUpperCase()
                            : 'SU'
                    }} -->
                    <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60"
                        fill="none">
                        <path
                            d="M50 52.5C50 49.0111 50 47.2666 49.5694 45.8471C48.5999 42.6511 46.0989 40.1501 42.9029 39.1806C41.4834 38.75 39.7389 38.75 36.25 38.75H23.75C20.2611 38.75 18.5166 38.75 17.0971 39.1806C13.9011 40.1501 11.4001 42.6511 10.4306 45.8471C10 47.2666 10 49.0111 10 52.5M41.25 18.75C41.25 24.9632 36.2132 30 30 30C23.7868 30 18.75 24.9632 18.75 18.75C18.75 12.5368 23.7868 7.5 30 7.5C36.2132 7.5 41.25 12.5368 41.25 18.75Z"
                            stroke="#FAFAFA" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
        <div class="caller-wrapper">
            <span>{{ dialNumber }}</span>
            <p v-if="callDuration === 0">{{ callingText }}</p>
            <p v-else>{{ Math.floor(callDuration / 60) }}:{{ String(callDuration % 60).padStart(2, '0') }}</p>
        </div>
    </div>
    <div class="call-action">
        <div @click="emit('closeDialog')" class="action-wrapper">
            <PrimeButton label="End Call" class="w-full p-btn-root_error" variant="error">
                <template #icon>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                        <path
                            d="M18.9594 13.8946C18.7942 14.1059 18.5654 14.2586 18.3068 14.3299C18.0483 14.4012 17.7736 14.3875 17.5234 14.2907L15.5891 12.8063C15.574 12.7953 15.5601 12.7827 15.5477 12.7688L9.02968 5.59537C8.99056 5.55261 8.9641 5.49981 8.95326 5.44287C8.94241 5.38594 8.94762 5.32711 8.96829 5.27297C8.98896 5.21882 9.02428 5.17149 9.0703 5.13626C9.11632 5.10104 9.17124 5.0793 9.2289 5.07349C12.5883 4.71255 16.0836 5.78599 18.593 8.29536C20.1547 9.85708 20.3055 12.1594 18.9594 13.8946ZM4.71328 2.70474C4.65839 2.64287 4.59177 2.59251 4.51728 2.55658C4.44278 2.52064 4.3619 2.49985 4.27931 2.49541C4.19672 2.49097 4.11408 2.50296 4.03616 2.53069C3.95824 2.55843 3.8866 2.60135 3.82539 2.65697C3.76419 2.7126 3.71463 2.77982 3.67959 2.85474C3.64455 2.92965 3.62473 3.01078 3.62128 3.09342C3.61783 3.17605 3.63081 3.25855 3.65948 3.33613C3.68814 3.41371 3.73192 3.48483 3.78828 3.54536L5.94609 5.91958C4.62392 6.4753 3.42205 7.28212 2.40703 8.29536C0.844526 9.85786 0.694526 12.1594 2.04062 13.8946C2.20579 14.1059 2.43457 14.2586 2.69315 14.3299C2.95172 14.4012 3.22639 14.3875 3.47656 14.2907L7.30468 12.9336L7.32734 12.9251C7.52045 12.8478 7.69125 12.7237 7.82426 12.5638C7.95727 12.4039 8.04829 12.2134 8.08906 12.0094L8.55 9.70396C8.76921 9.62828 8.99279 9.56593 9.21953 9.51724L16.2898 17.2954C16.3447 17.3572 16.4113 17.4076 16.4858 17.4435C16.5603 17.4795 16.6412 17.5003 16.7238 17.5047C16.8064 17.5091 16.889 17.4971 16.967 17.4694C17.0449 17.4417 17.1165 17.3988 17.1777 17.3431C17.2389 17.2875 17.2885 17.2203 17.3235 17.1454C17.3586 17.0705 17.3784 16.9893 17.3818 16.9067C17.3853 16.8241 17.3723 16.7416 17.3436 16.664C17.315 16.5864 17.2712 16.5153 17.2148 16.4547L4.71328 2.70474Z"
                            fill="white" />
                    </svg>
                </template>
            </PrimeButton>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useContactsTempStore } from '~/stores/person/contacts-temp';

const emit = defineEmits(['closeDialog']);
const store = useContactsTempStore();

const dialNumber = ref(store.selectedContact?.phone_numbers[0]?.phone_full || '555-867-5309');

const callDuration = ref(0);
const callingText = ref('calling.');
let callInterval: NodeJS.Timeout | null = null;
let callingInterval: NodeJS.Timeout | null = null;

const startCallCounter = () => {
    setTimeout(() => {
        callInterval = setInterval(() => {
            callDuration.value += 1;
        }, 1000);
    }, 3000);
};

const startCallingAnimation = () => {
    const states = ['calling.', 'calling..', 'calling...'];
    let index = 0;

    callingInterval = setInterval(() => {
        callingText.value = states[index];
        index = (index + 1) % states.length;
    }, 500);
};

const stopCallCounter = () => {
    if (callInterval) {
        clearInterval(callInterval);
    }
    if (callingInterval) {
        clearInterval(callingInterval);
    }
};

onMounted(() => {
    startCallingAnimation();
    startCallCounter();
});

onUnmounted(() => {
    stopCallCounter();
});
</script>
<style lang="scss" scoped>
.main-inc {
    @apply flex flex-col justify-center items-center pt-6 gap-6 w-32 mx-auto ;

    span {
        @apply text-center font-inter text-lg font-semibold not-italic text-white;
    }
    p {
        @apply text-center font-inter text-base font-normal not-italic text-zinc-400 ;
    }
    .caller-wrapper {
        @apply flex flex-col justify-center w-full ;
    }
}
.call-action {
    @apply w-full flex pt-8 flex-row items-center;

    .action-wrapper {
        @apply w-full flex flex-row items-center justify-center gap-6 px-6 pb-6;
    }
}
.avatar {
    @apply flex justify-center items-center w-32 h-32 shrink-0 rounded-full border border-[#000] bg-[#18181B] text-[#006df5] text-center font-[Inter] text-[14px] font-semibold leading-[14px];
}
.avatar-div {
    @apply relative items-center justify-center;
}
.pulse-dot {
    @apply relative flex items-center justify-center;
}
.pulse-dot :deep(svg),
.pulse-dot :deep(img) {
    @apply w-16 h-[60px];
}
.pulse-dot::before,
.pulse-dot::after {
    content: '';
    @apply absolute rounded-full;
    width: 70%;
    height: 70%;
    border: 2px solid #71717b;
    background-color: transparent;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.pulse-dot::before {
    animation: pulse-ring 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.pulse-dot::after {
    animation: pulse-ring 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    animation-delay: 0.6s;
}
.pulse-dot:has(svg)::before,
.pulse-dot:has(img)::before,
.pulse-dot:has(svg)::after,
.pulse-dot:has(img)::after {
    animation-name: pulse-ring-with-icon;
}
@keyframes pulse-ring {
    0% {
        width: 100%;
        height: 100%;
        opacity: 1;
    }

    100% {
        width: 300%;
        height: 300%;
        opacity: 0;
    }
}

@keyframes pulse-ring-with-icon {
    0% {
        width: 100%;
        height: 100%;
        opacity: 1;
    }

    100% {
        width: 200%;
        height: 200%;
        opacity: 0;
    }
}
</style>
